module.exports = __webpack_public_path__ + "static/media/kavak-mx-logo.b2448a58.png";